import api from './api';

const CATEGORY_ENDPOINTS = {
  LIST: '/admin/categories/',
  TREE: '/admin/categories/tree/',
  TREE_LAZY: '/admin/categories/tree-lazy/',
  CHILDREN: (sid) => `/admin/categories/tree-lazy/${sid}/children/`,
  DETAIL: (id) => `/admin/categories/${id}/`,
  TRANSLATIONS: (id) => `/admin/categories/${id}/translations/`,
  ATTRIBUTES: (id) => `/admin/categories/${id}/attributes/`,
  PUBLIC_TREE: '/v1/app/categories/public/tree/',
};

/**
 * Get all categories (list view)
 */
export const getCategories = async (params = {}) => {
  try {
    const response = await api.get(CATEGORY_ENDPOINTS.LIST, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching categories:', error);
    throw error;
  }
};

/**
 * Get category tree structure
 */
export const getCategoryTree = async (params = {}) => {
  try {
    const response = await api.get(CATEGORY_ENDPOINTS.TREE, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching category tree:', error);
    throw error;
  }
};

/**
 * Get single category by ID
 */
export const getCategoryById = async (id) => {
  try {
    const response = await api.get(CATEGORY_ENDPOINTS.DETAIL(id));
    return response.data;
  } catch (error) {
    console.error('Error fetching category:', error);
    throw error;
  }
};

/**
 * Create new category
 */
export const createCategory = async (data) => {
  try {
    const response = await api.post(CATEGORY_ENDPOINTS.LIST, data);
    return response.data;
  } catch (error) {
    console.error('Error creating category:', error);
    throw error;
  }
};

/**
 * Update category
 */
export const updateCategory = async (id, data) => {
  try {
    const response = await api.put(CATEGORY_ENDPOINTS.DETAIL(id), data);
    return response.data;
  } catch (error) {
    console.error('Error updating category:', error);
    throw error;
  }
};

/**
 * Delete category
 */
export const deleteCategory = async (id, force = false) => {
  try {
    const response = await api.delete(CATEGORY_ENDPOINTS.DETAIL(id), {
      params: { force }
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting category:', error);
    throw error;
  }
};

/**
 * Get category translations
 */
export const getCategoryTranslations = async (categoryId) => {
  try {
    const response = await api.get(CATEGORY_ENDPOINTS.TRANSLATIONS(categoryId));
    return response.data;
  } catch (error) {
    console.error('Error fetching category translations:', error);
    throw error;
  }
};

/**
 * Get category attributes
 */
export const getCategoryAttributes = async (categoryId) => {
  try {
    const response = await api.get(CATEGORY_ENDPOINTS.ATTRIBUTES(categoryId));
    return response.data;
  } catch (error) {
    console.error('Error fetching category attributes:', error);
    throw error;
  }
};

/**
 * Create category attribute
 */
export const createCategoryAttribute = async (categoryId, data) => {
  try {
    const response = await api.post(CATEGORY_ENDPOINTS.ATTRIBUTES(categoryId), data);
    return response.data;
  } catch (error) {
    console.error('Error creating category attribute:', error);
    throw error;
  }
};

/**
 * Get public category tree (for testing)
 */
export const getPublicCategoryTree = async () => {
  try {
    const response = await api.get(CATEGORY_ENDPOINTS.PUBLIC_TREE);
    return response.data;
  } catch (error) {
    console.error('Error fetching public category tree:', error);
    throw error;
  }
};

/**
 * Get lazy-loaded category tree (top-level only)
 */
export const getCategoryTreeLazy = async (params = {}) => {
  try {
    const response = await api.get(CATEGORY_ENDPOINTS.TREE_LAZY, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching lazy category tree:', error);
    throw error;
  }
};

/**
 * Get children of a specific category
 */
export const getCategoryChildren = async (categorySid, params = {}) => {
  try {
    const response = await api.get(CATEGORY_ENDPOINTS.CHILDREN(categorySid), { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching category children:', error);
    throw error;
  }
};

